import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@arcadeai/design-system/components/ui/atoms/tooltip";
import { TagsInput } from "@arcadeai/design-system/components/ui/molecules/tags-input";
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@arcadeai/design-system/rhf";
import { Info } from "lucide-react";
import type { Control } from "react-hook-form";
import { useWatch } from "react-hook-form";
import type { McpServerCreateRequest } from "../../types";

type ConsentSkipClientIdsFieldProps = {
  control: Control<McpServerCreateRequest>;
};

export const ConsentSkipClientIdsField = ({
  control,
}: ConsentSkipClientIdsFieldProps) => {
  const authType = useWatch({ control, name: "auth_type" });

  if (authType === "arcade_header") {
    return null;
  }

  return (
    <FormField
      control={control}
      name="consent_skip_client_ids"
      render={({ field }) => {
        const ids: string[] = field.value ?? [];
        return (
          <FormItem>
            <div className="flex items-center gap-1.5">
              <FormLabel>Skip consent for trusted clients (optional)</FormLabel>
              <TooltipProvider delay={150}>
                <Tooltip>
                  <TooltipTrigger
                    render={
                      <button
                        aria-label="What is an MCP Client ID?"
                        className="inline-flex items-center text-muted-foreground hover:text-foreground"
                        type="button"
                      />
                    }
                  >
                    <Info className="size-3.5" />
                  </TooltipTrigger>
                  <TooltipContent className="max-w-xs" side="top">
                    The client_id sent by the MCP client during OAuth
                    registration (e.g.
                    https://claude.ai/oauth/mcp-oauth-client-metadata). Users
                    connecting from a listed client will skip the Arcade consent
                    screen.
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </div>
            <FormControl>
              <TagsInput
                onChange={field.onChange}
                placeholder="Add MCP client ID…"
                values={ids}
              />
            </FormControl>
            <FormDescription>
              MCP client IDs whose users skip the Arcade consent screen. Press
              Enter or comma to add.
            </FormDescription>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
